import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import App from "./App";
import { GithubProvider } from "./context/context";
import { Auth0Provider } from "@auth0/auth0-react";

//daxus.us.auth0.com
//a19A5cAx1mptzHqGHSh3CfUKEQO3KZrb

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain="daxus.us.auth0.com"
      clientId="a19A5cAx1mptzHqGHSh3CfUKEQO3KZrb"
      redirectUri={window.location.origin}
      cacheLocation='localstorage'
    >
      <GithubProvider>
        <App />
      </GithubProvider>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
